import { useContext } from "react";

import { BankConnectConsentContext, type BankConnectContextValue } from "./BankConnectConsentContext";

export const useBankConnectConsent = (): BankConnectContextValue => useContext(BankConnectConsentContext);
